import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { dayMap } from 'shared/helpers/time-utils';
import { LocalSection } from '../customize/homepage/homepage-form.types';

type ScheduleTooltipContentProps = {
  schedule: LocalSection['collectionSchedule'];
  hideStartEndDate?: boolean;
};

// Formats time string (HH:mm) to 12-hour format (h:mm a)
function formatTime(time: string): string {
  return moment(time, 'HH:mm').format('h:mm A');
}

export function ScheduleTooltipContent({
  schedule,
  hideStartEndDate = false,
}: ScheduleTooltipContentProps): JSX.Element | null {
  if (!schedule) {
    return null;
  }

  const { startDate, endDate, timeRanges } = schedule;

  return (
    <Container>
      {!hideStartEndDate && (
        <DatesContainer>
          <div>Starts: {new Date(startDate).toLocaleDateString()}</div>
          {endDate && <div>Ends: {new Date(endDate).toLocaleDateString()}</div>}
        </DatesContainer>
      )}
      {timeRanges && timeRanges.length > 0 && (
        <TimeRangeList>
          {timeRanges.map((tr: { id: string; dayOfWeek: number; startTime: string; endTime: string }) => (
            <TimeRangeRow key={tr.id}>
              <DayColumn>{dayMap[tr.dayOfWeek]}</DayColumn>
              <TimeColumn>
                {formatTime(tr.startTime)} - {formatTime(tr.endTime)}
              </TimeColumn>
            </TimeRangeRow>
          ))}
        </TimeRangeList>
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const DatesContainer = styled.div``;

const TimeRangeList = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
`;

const TimeRangeRow = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: 1fr 1fr;
`;

const DayColumn = styled.div``;

const TimeColumn = styled.div`
  white-space: nowrap;
`;
